import type React from 'react';
import { useTranslation } from 'react-i18next';
import { MigrationAction } from './MigrationAction';
import { MigrationStateLayout } from './MigrationStateLayout';

interface RetryableStateProps {
  /** Which sentence names what happened; the action is the same for both. */
  reason: 'declined' | 'expired';
  isAdmin: boolean;
  /** i18n key naming why the API would refuse; when set, no action is offered. */
  blockedReasonKey: string | null;
  isStarting: boolean;
  onStart: () => void;
  currencyNotice?: string;
}

/** The merchant declined the last attempt, or its approval link expired. */
export const RetryableState: React.FC<RetryableStateProps> = ({
  reason,
  isAdmin,
  blockedReasonKey,
  isStarting,
  onStart,
  currencyNotice,
}) => {
  const { t } = useTranslation();

  // Written out rather than interpolated: a dynamic i18n key hides these two
  // strings from the orphan check, which then offers them up for deletion.
  const body = {
    declined: t('settings.subscription.successFeeMigration.declined.body'),
    expired: t('settings.subscription.successFeeMigration.expired.body'),
  }[reason];

  return (
    <MigrationStateLayout tone="error" status={body} currencyNotice={currencyNotice}>
      <MigrationAction
        isAdmin={isAdmin}
        blockedReasonKey={blockedReasonKey}
        isStarting={isStarting}
        onAct={onStart}
        actionKey="settings.subscription.successFeeMigration.retry.action"
        viewerHelperKey="settings.subscription.successFeeMigration.retry.viewerHelper"
      />
    </MigrationStateLayout>
  );
};
